import { render, staticRenderFns } from "./BonusesInModal.vue?vue&type=template&id=1751adf2&scoped=true&"
import script from "./BonusesInModal.vue?vue&type=script&lang=js&"
export * from "./BonusesInModal.vue?vue&type=script&lang=js&"
import style0 from "./BonusesInModal.vue?vue&type=style&index=0&id=1751adf2&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1751adf2",
  null
  
)

export default component.exports